import gql from "graphql-tag";
import { useTesQuery } from "./useTesQuery";

const GET_CUSTOMER = gql`
  query GetCustomer($id: String!) {
    customer(id: $id) {
      id
      name
      last_name
      email
      external_id
      address_line1
      address_line2
      city
      state
      postal_code
      country
      phone
      street
      data
      created_at
      updated_at
    }
  }
`;

export const useGetCustomer = (customerId, options = {}) => {
  return useTesQuery(
    GET_CUSTOMER,
    { id: customerId },
    {
      enabled: Boolean(customerId),
      ...options,
    }
  );
};
